import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {Program} from "../scratchpad-ui.tsx";

import type {
    spinOffProgram as spinOffProgramResult,
    spinOffProgramVariables,
} from "./__graphql-types__/spinOffProgram.ts";
import {mapToProgram} from "./gql-type-mappers.ts";
import {PROGRAM_FRAGMENT} from "./program-fragment.ts";

export const SPIN_OFF_PROGRAM: GqlOperation<
    spinOffProgramResult,
    spinOffProgramVariables
> = gqlOp(gql`
    mutation spinOffProgram(
        $originProgramOrContentId: String!
        $originProgramKind: SpinoffOriginKind!
        $originRevisionId: ID
        $title: String!
        $revision: ProgramRevisionInput!
        $curationNodeSlug: String!
    ) {
        spinOffProgram(
            origin: {
                programOrContentId: $originProgramOrContentId
                kind: $originProgramKind
            }
            originRevisionId: $originRevisionId
            title: $title
            revision: $revision
            curationNodeSlug: $curationNodeSlug
        ) {
            program {
                ...Program
            }
            error {
                code
                debugMessage
            }
        }
    }
    ${PROGRAM_FRAGMENT}
`);

export const spinOffProgram = async (
    gqlFetch: GqlFetchFn,
    variables: spinOffProgramVariables,
): Promise<Program> => {
    const result = await gqlFetch(SPIN_OFF_PROGRAM, {variables});
    const program = result.spinOffProgram?.program;
    if (!program) {
        throw new KAError("Failed to spin off program", Errors.Internal);
    }
    return mapToProgram(program);
};
